// Assets list page (CHG-1234 / ITER-3357).
//
// Thin per the v6 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates assetListConfig from
// asset.entity-hint.yaml without touching this file.
//
// Spec: specs/tier-05-experience/assets-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { assetListConfig } from "../generated/screens/asset-list";

export function Assets() {
  return <ListPage config={assetListConfig} />;
}
